import { FormItemProps, InputNumber } from 'antd';
import { FormItem } from 'src/components/Form/FormItem';
import styled from 'styled-components';

export type NumberFieldProps = FormItemProps & {
    label?: React.ReactNode;
    onlyInteger?: boolean;
    disabled?: boolean;
    stringMode?: boolean;
    thousandDivider?: boolean | string;
    inputNumberProps?: React.ComponentProps<typeof InputNumber>;
};

export const NumberField = ({
    name,
    label,
    onlyInteger,
    disabled,
    stringMode,
    inputNumberProps,
    ...props
}: NumberFieldProps) => {
    return (
        <FormItem {...props} name={name} label={label}>
            <StyledInputNumber
                {...inputNumberProps}
                disabled={disabled}
                stringMode={stringMode}
            />
        </FormItem>
    );
};

const StyledInputNumber = styled(InputNumber)`
    height: 40px;
    padding: 7px 12px;
    border-radius: 6px;
    width: 100%;

    .ant-input-number-handler-wrap {
        border-radius: 6px;
    }

    .ant-input-number-handler {
        height: 50% !important;
    }

    .ant-input-number-input-wrap,
    input {
        height: 22px;
    }
`;
